/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// import { pxToEm } from '@insticator/insticator-ui';



/* ++++++++++ --------------- TRENDING NOW V2 - ANALYTICS PAGE : STYLES --------------- ++++++++++ */
export default {
    trendingnowv2analayticspage: {
    }
};
